var _dec, _class, _TopNavBarDesktopLayout;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Children, Component } from 'react';
import { omitProps } from '@instructure/ui-react-utils';
import { withStyle } from '@instructure/emotion';
import { TopNavBarContext } from "../../TopNavBarContext.js";
import generateStyle from "./styles.js";
import generateComponentTheme from "./theme.js";
import { allowedProps } from "./props.js";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
---
private: true
---
**/
let TopNavBarDesktopLayout = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_TopNavBarDesktopLayout = class TopNavBarDesktopLayout extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props, this.makeStylesVariables);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2, this.makeStylesVariables);
  }
  get makeStylesVariables() {
    return {
      inverseColor: this.context.inverseColor,
      hasBrandBlock: this.hasBrandBlock,
      hasActionItemsBlock: this.hasActionItemsBlock,
      hasUserBlock: this.hasUserBlock
    };
  }
  get hasBrandBlock() {
    const renderBrand = this.props.renderBrand;
    return !!renderBrand && !!renderBrand.props.renderIcon;
  }
  get hasActionItemsBlock() {
    const renderActionItems = this.props.renderActionItems;
    return !!renderActionItems && Children.count(renderActionItems.props.children) > 0;
  }
  get hasUserBlock() {
    const renderUser = this.props.renderUser;
    return !!renderUser && Children.count(renderUser.props.children) > 0;
  }
  get hasMenuItemsBlock() {
    const renderMenuItems = this.props.renderMenuItems;
    return !!renderMenuItems && Children.count(renderMenuItems.props.children) > 0;
  }
  get hasBreadcrumbBlock() {
    const renderBreadcrumb = this.props.renderBreadcrumb;
    return !!renderBreadcrumb && Children.count(renderBreadcrumb.props.children) > 0;
  }
  render() {
    const _this$props3 = this.props,
      renderBrand = _this$props3.renderBrand,
      renderMenuItems = _this$props3.renderMenuItems,
      renderActionItems = _this$props3.renderActionItems,
      renderUser = _this$props3.renderUser,
      renderBreadcrumb = _this$props3.renderBreadcrumb,
      navLabel = _this$props3.navLabel,
      styles = _this$props3.styles;

    // only render breadcrumb if there is no brand or menu items
    const shouldRenderBreadcrumbBlock = !(this.hasBrandBlock || this.hasMenuItemsBlock) && this.hasBreadcrumbBlock;
    return _jsxs("nav", {
      ...omitProps(this.props, allowedProps),
      ref: this.handleRef,
      css: styles === null || styles === void 0 ? void 0 : styles.topNavBarDesktopLayout,
      "aria-label": navLabel,
      "data-cid": "TopNavBarDesktopLayout",
      children: [this.hasBrandBlock && _jsx("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.brandContainer,
        children: renderBrand
      }), this.hasMenuItemsBlock && _jsx("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.menuItemsContainer,
        children: renderMenuItems
      }), shouldRenderBreadcrumbBlock && renderBreadcrumb, _jsx("span", {
        css: styles === null || styles === void 0 ? void 0 : styles.spacer
      }), this.hasActionItemsBlock && _jsx("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.actionItemsContainer,
        children: renderActionItems
      }), this.hasUserBlock && _jsx("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.userContainer,
        children: renderUser
      })]
    });
  }
}, _TopNavBarDesktopLayout.displayName = "TopNavBarDesktopLayout", _TopNavBarDesktopLayout.componentId = 'TopNavBar.DesktopLayout', _TopNavBarDesktopLayout.allowedProps = allowedProps, _TopNavBarDesktopLayout.defaultProps = {}, _TopNavBarDesktopLayout.contextType = TopNavBarContext, _TopNavBarDesktopLayout)) || _class);
export { TopNavBarDesktopLayout };
export default TopNavBarDesktopLayout;